const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg
    viewBox="0 0 48 48"
    className={className}
    fill="none"
    aria-hidden="true"
    data-testid="logo-mark"
  >
    <path
      d="M9 40 L24 9 L39 40"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="square"
    />
    <path
      d="M16 30 L32 30"
      stroke="#D4AF37"
      strokeWidth="2.5"
      strokeLinecap="square"
    />
  </svg>
);

export default LogoMark;
